import styled from 'styled-components'
import RCardPrimary from '../RCardPrimary'

export const ResultCard = styled(RCardPrimary)`
  .ant-card-body {
    padding: 0px;
  }
`
